import { render, staticRenderFns } from "./GroupOneRaceHeader.vue?vue&type=template&id=f3a538f6"
import script from "./GroupOneRaceHeader.vue?vue&type=script&lang=js"
export * from "./GroupOneRaceHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports